import { ProjectModel } from "./projects.data";
import coverImage from "../../../assets/images/covers/mini/as-dev.png";
import logo from "../../../assets/logos/lm-logo.png";
import logoCLB from "../../../assets/logos/centre-la-bonte.png";
import logoSomap from "../../../assets/logos/somap.png";
import logoW3D from "../../../assets/logos/w3d.png";
import logoAsa from "../../../assets/logos/asa.png";
import skinImg from "../../../assets/images/projects/dev-img-list/skin-ceuticals.png";
import hmImg from "../../../assets/images/image-list/developer-img-list/ppc.png";
import zakaImg from "../../../assets/images/image-list/developer-img-list/zaka.png";
import clbImg from "../../../assets/images/image-list/developer-img-list/centre-la-bontE.png";
import fenoImg from "../../../assets/images/image-list/developer-img-list/feno.png";
import gtmImg from "../../../assets/images/projects/dev-img-list/gtm.png";
import portfolioImg from "../../../assets/images/projects/dev-img-list/portfolio.png";

/* ENGLISH */
const projectsEnglish: ProjectModel[] = [
  {
    title: "SkinCeuticals",
    description: "A web application for marketing products in virtual reality.",
    logo: logoW3D,
    image: skinImg,
  },
  {
    title: "Hospital Manager",
    description: "Patient manager for psychiatric hospitals in Madagascar.",
    logo: logoSomap,
    image: hmImg,
  },
  {
    title: "ZAKA",
    description:
      "A social network that links suppliers directly to the consumer.",
    logo: logoAsa,
    image: zakaImg,
  },
  {
    title: "Centre La Bonté",
    description: "Accounting software.",
    logo: logoCLB,
    image: clbImg,
  },
  {
    title: "FENO",
    description: "Realistic clone of facebook lite with a backoffice.",
    logo,
    image: fenoImg,
  },
  {
    title: "GTM Bellville",
    description: "Virtual visit of a flat online.",
    logo: logoW3D,
    image: gtmImg,
  },
  {
    title: "This Portfolio",
    description: "I created this web application with ReactJS.",
    logo,
    image: portfolioImg,
  },
];

/* FRENCH */
const projectsFrench: ProjectModel[] = [
  {
    title: "SkinCeuticals",
    description:
      "Une application web pour la commercialisation de produits en réalité virtuelle.",
    logo: logoW3D,
    image: skinImg,
  },
  {
    title: "Hospital Manager",
    description:
      "Gestionnaire de patients pour les hôpitaux psychiatriques de Madagascar.",
    logo: logoSomap,
    image: hmImg,
  },
  {
    title: "ZAKA",
    description:
      "Un réseau social qui relie directement les fournisseurs au consommateur.",
    logo: logoAsa,
    image: zakaImg,
  },
  {
    title: "Centre La Bonté",
    description: "Logiciel de comptabilité.",
    logo: logoCLB,
    image: clbImg,
  },
  {
    title: "FENO",
    description: "Clone réaliste de facebook lite avec un backoffice.",
    logo,
    image: fenoImg,
  },
  {
    title: "GTM Bellville",
    description: "Visite virtuelle d'un appartement en ligne.",
    logo: logoW3D,
    image: gtmImg,
  },
  {
    title: "Ce Portfolio",
    description: "J'ai créé cette application web avec ReactJS.",
    logo,
    image: portfolioImg,
  },
];

export const developerProjectsEnglishData = {
  label: "developer",
  title: "DEVELOPER",
  subtitle: "My projects as",
  cover: coverImage,
  projects: projectsEnglish,
};

export const developerProjectsFrenchData = {
  label: "developer",
  title: "DEVELOPPEUR",
  subtitle: "En tant que",
  cover: coverImage,
  projects: projectsFrench,
};
